import { IdModal } from "../../modals/IdModal";
import { BuildingCategory } from "../../player-base/buildings/BuildingCategory";
import { createPathSelectTabInModal } from "../../show-me/path/createPathSelectTabInModal";
export var pathSelectSpecialDecorationTabInBuildMenu = function (action, state$, deps) {
    return createPathSelectTabInModal(function () { return IdModal.BuildingList; }, function () { return BuildingCategory.SpecialDecorations; })(action, state$, deps);
};



//////////////////
// WEBPACK FOOTER
// ./src/features/themed-events/paths/pathSelectSpecialDecorationTabInBuildMenu.ts
// module id = 2426
// module chunks = 3